import {
    createSelector
} from 'reselect'

export const tokenSelector = createSelector(state => state && state.auth && state.auth.token, tokenSelector => tokenSelector);
export const isAuthenticatedSelector = createSelector(state => state && state.auth && state.auth.isAuthenticated, isAuthenticatedSelector => isAuthenticatedSelector);
export const userInfoSelector = createSelector(state => state && state.auth && state.auth.userInfo, userInfoSelector => userInfoSelector);
export const usersSelector = createSelector(state => state && state.auth && state.auth.users, usersSelector=>usersSelector);

export const rfidSelector = createSelector(state => state && state.auth && state.auth.rfid, rfidSelector=>rfidSelector);
export const employeesSelector = createSelector(state => state && state.auth && state.auth.employees, employeesSelector=>employeesSelector);

export const selectedCompanyIdSelector = createSelector(state => state && state.auth && state.auth.userInfo && state.auth.userInfo.selectedLocationId, selectedCompanyIdSelector=>selectedCompanyIdSelector);

export const showLicenseDialogSelector = createSelector(state => state && state.auth && state.auth.showLicenseDialog, showLicenseDialogSelector=>showLicenseDialogSelector);
export const onlineEmployeesSelector = createSelector(state => state && state.auth && state.auth.onlineEmployees, onlineEmployeesSelector=>onlineEmployeesSelector);
